import React, { useContext, useEffect, ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

interface Props {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: Props): ReactElement | null {
  const navigate = useNavigate();
  const { authenticationObject } = useContext(AuthContext);

  const isAuthenticated = authenticationObject.access_token !== ''
    && authenticationObject.organisation !== ''
    && authenticationObject.license_types.length !== 0;

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // If not authenticated, don't render anything (will redirect)
  if (!isAuthenticated) {
    return null;
  }

  return children as ReactElement;
}

export default ProtectedRoute;
